<div class="scroll-down-button">
  <a  class="scroll-down" address="true" (click)="handleScroll()"></a>
</div>
